import styled from 'styled-components';
import { globalTheme } from '@clds/component-theme';
import { media } from '@clds/style-utils';
import { CircleSkeleton, TextSkeleton } from '@cld/skeleton';
import { theme as t } from '../CustomTransformationCardTheme';

const { font, spacing } = globalTheme;

export const ThumbnailSkeleton = styled(CircleSkeleton)`
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  z-index: 0;
  padding: ${globalTheme.spacing.md};

  @media ${media.phone()} {
    padding: ${globalTheme.spacing.xs};
    width: ${t.avatarSkeleton.onPhone.width};
    height: ${t.avatarSkeleton.onPhone.height};
  }
`;

export const TitleSkeleton = styled(TextSkeleton)`
  height: ${font.size.xs};
  width: 300px;
  max-width: 100%;
  margin-bottom: ${spacing.sm};
`;

export const InfoSkeleton = styled(TextSkeleton)`
  height: ${font.size.xs};
  width: 200px;
  margin-top: ${spacing.xs};
`;
